import Layout from '../components/Layout';
import PropertyImportWizard from '../components/PropertyImportWizard';

export default function PropertyImport() {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="font-display text-[28px] font-semibold uppercase leading-[1.06] tracking-[-.01em] text-gray-900 sm:text-[32px]">Import Properties</h1>
          <p className="text-gray-500 mt-1">
            Upload title, CoStar, or other data sources with automatic conflict detection.
          </p>
        </div>
        <PropertyImportWizard />
      </div>
    </Layout>
  );
}
